export default {
  dashboard: {
    name: "Tên",
    template: "Bản mẫu",
    dashboardWidget: "Widgets bảng dữ liệu",
    dashboardItem: "Mục bảng điều khiển",
    searchItem: "Mục  tìm kiếm",
    title: "Tiêu đề",
    contentTemplate: "Mẫu nội dung",
    colCount: "Số cột",
    sqlQuery: "Truy vấn SQL",
    enabledPagination: "Kích hoạt phân trang",
    active: "Kích hoạt",
    tableName: "Tên bảng",
    fieldName: "Tên trường",
    fieldType: "Loại trường",
    columnName: "Tên cột",
    columnType: "Loại cột",
    groupType: "Nhóm",
    orderValue:"Thứ tự sắp xếp",
    widthClass:"Chiều rộng",
    availableParams: "Các tham số cho truy vấn SQL",
    controlType: "Loai control",
    optionType: "Loại option",
    optionValue: "Giá trị option",
    templateTitle: "Tiêu đề mẫu",
    layout: "Layout",
    updatedAt: "Lần thay đổi cuối",
    defaultRowCount: "Sô hàng mặc định",
    defaultColCount: "Số cột mặc định",
    defaultLoadingInterval: "Khoảng thời gian làm mới mặc định",
    loadingInterval: "Khoảng thời gian làm mới",
    defaultDateRange: "Giá trị thời gian mặc định",
    enabledSearch: "Cho phép tiềm kiếm",
    enabledExcel: "Cho phéo truy xuất excel",
    enabledPrint: "Cho phép in",
    generatedSql:"Truy vấn được tạo",
    executeQuery:"Thực thi truy vấn",
    paramsNote:"Chú ý: các tham số nên được đặt trong block {} để có thể bị xóa khi không có giá trị.",
    paramsNoteEx:"Ví dự: {AND fieldName = :fieldName}",
    queryResult:"Kết quả truy vấn",
    errorMessage:"Thông báo lỗi",
    executionTime:"Thời gian thực thi",
    resultColumns: "Các cột kết quả",
    editColumn: "Thay đổi cột",
    enableRender: "Cho phép thay thể bởi nhãn",
    renderValues: "Tham chiếu giá trị-nhãn",
    enableLink:"Cho phéo gắn liên kết",
    linkUrl:"Đường dẫn liên kết",
    linkParams:"Tham số liên kết",
    linkMethod:"Giao thức liên kết",
    value:"Giá trị",
    displayLabel:"Nhãn hiển thị",
    collectionTable: "Các bảng thu thập",
    fraudTotal: "Trang thống kê fraud",
    fraudResponse:"Kết quả fraud",
    fraudResponseItem:"Mục kết quả fraud",
    itemLink:"Liên kết",
    linkSql: "Truy vấn SQL của liên kết",
    queryResultDetail:"Kết quả truy vấn chi tiết",
    detailSqlQuery:"Truy vấn SQL cho trang chi tiết",
    availableLinkParams:"Tham số cho liên kết",
    key: "Khóa",
    linkParamName: "Tên tham số hoặc giá trị",
    menu: "Menu",
    showOnDashboardMode:"Hiển thị ở chế độ Dashboard ",
    widget: "Widget bảng điều khiển",
    createSearchField:"Tạo mục tìm kiếm",
    editSearchField:"Thay đổi mục tìm kiếm"
  }
};
